// removed by extract-text-webpack-plugin
module.exports = {"imageContainer":"_1-2Dz","teaser":"_3zVdl","highlighted":"_3BaRV","background_color":"GufRb","header":"_3ZhO3","button_wrapper":"_2omq3","button_wrapper_left":"_1jQeX","teaserMobile":"_37uDK _3zVdl","content":"_1b0vr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Teaser/style.scss
// module id = wDJL
// module chunks = 0